const animation = {
  "ani_01_title": "<span>大師級</span><span><em>匠藝</em></span><span><em>美學</em></span>",
  "ani_02_title": "<span><em>創新</em></span><span> LACREON®</span><span>水凝科技</span>",
  "ani_03_title": "<span>無異物感的</span><span><em>滑順</em></span><span>邊緣設計</span>",
  "ani_04_title": "<span><em>可信賴</em></span><span><em>的</em></span><span>精密工藝</span>",
  "ani_01_content": "安視優®以創新精神及「自然、科學、藝術」的極致工藝，搭配由藝術家匠心手繪的仿虹膜花紋設計，透過精緻細膩的技術，讓彩色隱形眼鏡能與您的雙眼自然融合，輕鬆打造高級感明亮眼神。戴上睛漾水凝®，綻放雙眸光彩。",
  "ani_02_content": "將保濕因子 20 小時鎖在鏡片中，維持雙眼全日配戴水潤舒適。",
  "ani_03_content": "鏡片採用輕薄邊緣設計，降低新手配戴時可能有的異物感，提供舒適的配戴感。",
  "ani_04_content": "高品質、安全、安心的全球隱形眼鏡領導品牌。",
}

export default animation

